import * as aTypes from "../actions/actionTypes";
import { filtersModel } from "../../models/filters";
import { updateObject, checkExist, simplestText } from "../../helpers/index";
import * as kAnalyticsHelper from "../../helpers/analyticsHelpers";
import * as kFilters from "../../constants/filters";

const initialState = {
  filters: filtersModel,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case aTypes.LIST_FILTERS_ACTIVTS_SET:
      return setFiltersActivities(state, action);

    case aTypes.LIST_FILTERS_ACTIVTS_RESET:
      return resetFiltersActivities(state, action);

    case aTypes.ACTIVE_FILTER_TYPE:
      return toggleFilterType(state, action);

    case aTypes.ACTIVE_FILTER_DIFFICULTY:
      return toggleFilterDifficulty(state, action);

    case aTypes.ACTIVE_FILTER_ABILITY_FONO:
      return toggleFilterAbilityFono(state, action);

    case aTypes.ACTIVE_FILTER_ABILITY_PAID:
      return toggleFilterAbilityPaid(state, action);

    case aTypes.ACTIVE_FILTER_ABILITY_FREE:
      return toggleFilterAbilityFree(state, action);

    case aTypes.ACTIVE_FILTER_AGE_RANGE:
      return toggleFilterAgeRange(state, action);

    case aTypes.ACTIVE_FILTER_LANGUAGE:
      return toggleFilterLanguage(state, action);

    default:
      return state;
  }
};

const setFiltersActivities = (state, action) => {
  return updateObject(state, {
    filters: updateObject(state.filters, action.filters),
  });
};

const resetFiltersActivities = (state, action) => {
  let _filter = JSON.parse(JSON.stringify(filtersModel));
  return { filters: { ..._filter } };
};



const toggleFilterType = (state, action) => {
  let newTotal = state.filters.active.total;
  let typesTotal = state.filters.active.type.total;
  const types = state.filters.active.type;

  types[action.key] = !state.filters.active.type[action.key];

  if (types[action.key] === true) {
    newTotal -= 1;
    typesTotal -= 1;
  } else if (types[action.key] === false) {
    newTotal += 1;
    typesTotal += 1;
  }
  if (action.forceUpdate) {
    for (let key in types) {
      types[key] = true;
    }
  }

  types.total = typesTotal;
  kAnalyticsHelper.setAnalyticsFilterByType({
    value: kFilters.FRIENDLY_FILTERS(action.key),
    type: kFilters.FRIENDLY_FILTERS(kFilters.FILTER_BY_TYPE),
  });

  return updateObject(state, {
    filters: updateObject(state.filters, {
      active: updateObject(state.filters.active, {
        total: newTotal,
        type: types,
      }),
      totalActive: newTotal,
    }),
  });
};

const toggleFilterDifficulty = (state, action) => {
  return toggleFilter(state, action, kFilters.FILTER_BY_DIFFICULTIES);
};

const toggleFilterAbilityFono = (state, action) => {
  return toggleFilter(state, action, kFilters.FILTER_BY_ABILITY_FONO);
};

const toggleFilterAbilityPaid = (state, action) => {
  return toggleFilter(state, action, kFilters.FILTER_BY_ABILITY_PAID);
};

const toggleFilterAbilityFree = (state, action) => {
  return toggleFilter(state, action, kFilters.FILTER_BY_ABILITY_FREE);
};

const toggleFilterAgeRange = (state, action) => {
  return toggleFilter(state, action, kFilters.FILTER_BY_AGE_RANGE);
};

const toggleFilterLanguage = (state, action) => {
  return toggleFilter(state, action, kFilters.FILTER_BY_LANGUAGE);
};

const toggleFilter = (state, action, type) => {
  const infoMap = _updateInfo(
    state.filters.active[type],
    action,
    state.filters.active.total,
    type,
    state
  );
  console.log("infoMap return: ",infoMap)
  const result = updateObject(state, {
    filters: updateObject(state.filters, {
      active: updateObject(state.filters.active, {
        total: infoMap.data.total,
        [type]: updateObject(state.filters.active[type], infoMap.data),
      }),

      totalActive: infoMap.data.total,
    }),
  });
  return result;
};

const _updateInfo = (data = "", action, totalFilters, filterType, state) => {
  const key = action.key;
  const infoMap = [];
  infoMap.data = { ...data };
  if (checkExist(infoMap.data[key])) {
    if (action.forceUpdate) {
      infoMap.data[key] = checkExist(infoMap.data[key]) ? null : key;
    } else {
      return infoMap;
    }
  } else {
    infoMap.data[key] = key;
  }
  // infoMap.data[key]= checkExist(infoMap.data[key])? null: key;
  let newArrays = {};
  for (let _key in state.filters.all) {
    if (state.filters.all.hasOwnProperty(_key)) {
      let value = state.filters.all[_key];
      // Verificar se a entrada é um array
      if (Array.isArray(value)) {
        newArrays[_key] = value.map(() => value == key);
      }
      // Verificar se a entrada é um objeto (e não null)
      else if (value !== null && typeof value === "object") {
        newArrays[_key] = Object.keys(value).map((item) => item == key);
        Object.keys(value).findIndex((element,index) => {
          if (element == key){
            newArrays[_key][index] = !newArrays[_key][index];
          }
        });
      }
      // Caso contrário, criar um array com um único elemento baseado na comparação
      else {
        newArrays[_key] = [false];
      }
    }
  }

  infoMap.data.checkedArray = newArrays[filterType];
  console.log("infoMap.data: ", infoMap.data);
  const isNewData = checkExist(infoMap.data[key]);
  if (isNewData) {
    kAnalyticsHelper.setAnalyticsFilterByType({
      value: key,
      type: kFilters.FRIENDLY_FILTERS(filterType),
    });
    infoMap.total = parseInt(totalFilters) + 1;
    infoMap.data.total = parseInt(infoMap.data.total) + 1;
  } else {
    infoMap.total = parseInt(totalFilters) - 1;
    infoMap.data.total = parseInt(infoMap.data.total) - 1;
  }
  console.log("infoMap.data after: ", infoMap.data);
  return infoMap;
};
export default reducer;
